import React from 'react';
import useModal from '../hooks/useModal';
import LoginModal from './LoginModal';
import SignupModal from './SignupModal';
import '../styles/Header.css';

function Header() {
  const login = useModal();
  const signup = useModal();

  return (
    <header>
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-569NZGQ4"
          title="gtm"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>

      <div className="container desktop-header-inner">
        <div className="header-left">
          <a href="/">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c"
              alt="ft"
              className="logo"
              width="83"
              height="30"
            />
          </a>
        </div>

        {/* Navigation Menu */}
        <ul className="nav-bar" data-cy="desktop-nav">
          <li className="dropdown-new">
            <a href="/" className="menu-item">Home</a>
          </li>

          <li className="dropdown-new">
            <a href="#" className="menu-item">Talent</a>
            <ul className="dropdown-menu-new">
              <li><a href="/discovery">Discovery</a></li>
              <li><a href="/portfolio">Portfolio</a></li>
              <li><a href="/masterclass">MasterClass</a></li>
              <li><a href="/awards">Awards</a></li>
              <li><a href="/opportunities">Opportunities</a></li>
              <li><a href="/projects">Projects</a></li>
            </ul>
          </li>

          <li className="dropdown-new">
            <a href="#" className="menu-item">Media</a>
            <ul className="dropdown-menu-new">
              <li><a href="/updates">Updates</a></li>
              <li><a href="/streaming">Streaming</a></li>
              <li><a href="/spotlight">Spotlight</a></li>
              <li><a href="/podcast">Podcast</a></li>
              <li><a href="/sponsor">Blogs</a></li>
              <li><a href="/testimonials">Testimonials</a></li>
              <li><a href="#">Connect with us on</a></li>
              <li><a href="#">YouTube LinkedIn Instagram Facebook Tiktok</a></li>
            </ul>
          </li>

          <li className="dropdown-new">
            <a href="#" className="menu-item">Brand Solutions</a>
            <ul className="dropdown-menu-new">
              <li><a href="/advertising">Advertising & PR</a></li>
              <li><a href="/marketing-package">Marketing Packages</a></li>
              <li><a href="/celebrity-campaigns">Celebrity Campaigns</a></li>
              <li><a href="/brand-ambassadors">Brand Ambassadors</a></li>
              <li><a href="/digital-marketing">Digital Marketing</a></li>
              <li><a href="/social-media-management">Social Media Management</a></li>
              <li><a href="/content-production">Content Production</a></li>
              <li><a href="/media-strategy">Media Strategy</a></li>
              <li><a href="/product-launch">Product Launch</a></li>
              <li><a href="/promotional-events">Promotional Events</a></li>
              <li><a href="/event-staff">Event Staff</a></li>
              <li><a href="/event-management">Event Management</a></li>
              <li><a href="/training">Training</a></li>
              <li><a href="/insights">Insights</a></li>
            </ul>
          </li>

          <li className="dropdown-new">
            <a href="#" className="menu-item">Community</a>
            <ul className="dropdown-menu-new">
              <li><a href="/join-flourishtalents-club">FlourishTalents Club</a></li>
              <li><a href="/exclusive-offers">Exclusive Offers</a></li>
              <li><a href="/merchandise">Merchandise</a></li>
              <li><a href="/events">Events</a></li>
              <li><a href="/vacancies">Vacancies</a></li>
              <li><a href="/member-portal">Member Portal</a></li>
              <li><a href="/our-partners">Partners</a></li>
              <li><a href="#">Connect with us on</a></li>
              <li><a href="#">LinkedIn Instagram Facebook Tiktok</a></li>
            </ul>
          </li>
        </ul>

        {/* Original Login/Signup Buttons & Modals */}
        <button onClick={login.openModal} className="button login-desktop-button">Log in</button>
        <button onClick={signup.openModal} className="button signup-desktop-button">Sign up</button>

        <LoginModal isOpen={login.isOpen} onClose={login.closeModal} />
        <SignupModal isOpen={signup.isOpen} onClose={signup.closeModal} />
      </div>
    </header>
  );
}

export default Header;
